<template>
  <svg class="scaledText" :viewBox="viewbox" preserveAspectRatio="xMidYMid meet">
    <text x="50%" y="50%" :font-size="props.fontSize" text-anchor="middle" dominant-baseline="central">
      <slot />
    </text>
  </svg>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  size: {
    type: Number,
    default: 100,
  },
  fontSize: {
    type: Number,
    default: 24,
  },
});

const viewbox = computed(() => {
  return `0 0 ${props.size} ${props.size}`;
});
</script>
<style lang="scss" scoped>
svg {
  color: var(--c__bg);
  fill: var(--c__bg);
  font-weight: bold;
}
</style>
